/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { showToast } from 'vant';
// import localCache from '@/utils/localCache';
// import { useEmptyStringFormat } from '@/hooks/fn';
import useCollectionCorrection from './hooks/useCollectionCorrection';
import { editCollectionInfo } from '@/service/operate/comprehensiveDaily';
export default defineComponent({
  name: 'collectionCorrection',
  components: {},
  setup: function setup() {
    var params = ref({
      date: dayjs().format('YYYY-MM-DD')
    });
    var router = useRouter();
    var _useCollectionCorrect = useCollectionCorrection(params),
      _useCollectionCorrect2 = _slicedToArray(_useCollectionCorrect, 2),
      collectionInfo = _useCollectionCorrect2[0],
      getCollectionInfoAsync = _useCollectionCorrect2[1];
    var confirmDate = function confirmDate(val) {
      params.value.date = dayjs(val).format('YYYY-MM-DD');
      getCollectionInfoAsync();
    };
    onMounted(function () {
      getCollectionInfoAsync();
    });
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return editCollectionInfo(collectionInfo.value);
            case 2:
              showToast('保存成功');
              router.back();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      collectionInfo: collectionInfo,
      getCollectionInfoAsync: getCollectionInfoAsync,
      confirmDate: confirmDate,
      submit: submit
    };
  }
});